import { render, staticRenderFns } from "./WelfareMeetingAdd.vue?vue&type=template&id=c5fe99cc&scoped=true"
import script from "./WelfareMeetingAdd.vue?vue&type=script&lang=js"
export * from "./WelfareMeetingAdd.vue?vue&type=script&lang=js"
import style0 from "./WelfareMeetingAdd.vue?vue&type=style&index=0&id=c5fe99cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fe99cc",
  null
  
)

export default component.exports